import useSWR from "swr";
import * as aiccAPI from "services/aiccCustomer";
import { AICC_SWR_CONFIG } from "./swrConfig";

/**
 * Conversation list for one sub-user + language + conversation type.
 *
 * The array key carries every request parameter, so changing any of them
 * refetches without a manual dependency array. The fetcher closes over the
 * arguments rather than destructuring the key — SWR's tuple key inference needs
 * casts under TS 4.1, and the key is only doing cache identity here.
 */
export function useAiccConversations(
  subUserId: string,
  languageId: number,
  conversationType: string,
  page: number,
  pageSize: number
) {
  const { data, error, isLoading, mutate } = useSWR(
    ["aicc/conversations", subUserId, languageId, conversationType, page, pageSize],
    () =>
      aiccAPI.fetchAiccConversations(subUserId, languageId, {
        type: conversationType,
        page,
        page_size: pageSize,
      }),
    AICC_SWR_CONFIG
  );

  return {
    conversations: data?.items ?? [],
    total: data?.total ?? 0,
    isLoading,
    isError: !!error,
    mutate,
  };
}
